<template>
	<div class="opted-in-list">
		<button class="betslip__details__row__value__award" @click="open">
			<span class="betslip__details__row__value__award__count"></span>
			<svg
				class="betslip__details__row__value__award__icon"
				viewBox="0 0 24 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M7.5 7.67001V6.70001C7.5 4.45001 9.31 2.24001 11.56 2.03001C14.24 1.77001 16.5 3.88001 16.5 6.51001V7.89001"
					stroke="#A9910B"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9.00001 22H15C19.02 22 19.74 20.39 19.95 18.43L20.7 12.43C20.97 9.99 20.27 8 16 8H8.00001C3.73001 8 3.03001 9.99 3.30001 12.43L4.05001 18.43C4.26001 20.39 4.98001 22 9.00001 22Z"
					stroke="#A9910B"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M15.4955 12H15.5045"
					stroke="#A9910B"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M8.49451 12H8.50349"
					stroke="#A9910B"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</button>

		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="opted-in-filter" v-if="optedInData.length > 0">
				<div class="opted-in-filter__group">
					<h3 class="opted-in-filter__group__title">Your Opted-In Offers</h3>
					<p class="opted-in-filter__group__desc">
						Select only one for this bet
					</p>
					<div class="opted-in-filter__group__actions">
						<div
							v-for="promo in optedInData"
							:key="promo.promo_id"
							:class="{
								'opted-in-filter__group__action': 1,
								active: promo.promo_id === selectedPromo.promo_id,
							}"
						>
							<button
								class="opted-in-filter__group__action__remove"
								@click="removeOptedInPromo(promo)"
							>
								&times;
							</button>
							<button
								class="opted-in-filter__group__action__apply"
								@click="apply(promo)"
							>
								<span class="opted-in-filter__group__action__name">{{
									promo.promo_name
								}}</span>
								<span class="opted-in-filter__group__action__desc">{{
									promo.description
								}}</span>
								<rules-indicator :rules="promo.rules" />
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="opted-in-filter__buttons">
				<button class="opted-in-filter__reset" @click="reset">Cancel</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import RulesIndicator from "./RulesIndicator.vue";
export default {
	name: "free-bets-optedIn-list",
	components: { RulesIndicator },
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	props: {
		optedInData: {
			type: Array,
			required: true,
			default: () => [],
		},
		selectedPromo: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		open() {
			this.canShowBottomSheet = true;
		},
		apply(promo) {
			this.closeBottomSheet();
			// this.$emit("apply");
			this.$emit("change-promo-option", promo);

			localStorage.setItem("selected-optIn", JSON.stringify(promo));
			window.dispatchEvent(
				new CustomEvent("selected-optIn-changed", {
					detail: {
						storage: localStorage.getItem("selected-optIn"),
					},
				})
			);
		},
		reset() {
			this.closeBottomSheet();
			this.$emit("reset");
			this.$emit("change-promo-option", {});
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
		removeOptedInPromo(promo) {
			let vm = this;
			vm.$store.dispatch("promos/optOutPromo", promo.promo_id);
			vm.$store.dispatch("promos/getPromos");
		},
	},
};
</script>

<style lang="scss">
.opted-in-filter {
	padding: 20px;
	&__buttons {
		padding: 0 10px 0px 10px;
	}
	&__button {
		font-size: var(--font-small);
		border: none;
		background: var(--light-gray);
		color: var(--black);
		border-radius: 25px;
		padding: 5px 10px;
		white-space: nowrap;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-right: 2px;
		&.main {
			margin-right: 20px;
		}
		&__label {
			flex: 5;
		}
		&__caret {
			flex-basis: 10px;
			fill: var(--black);
			margin-left: 5px;
			width: 12px;
			height: 8px;
			margin-bottom: -2px;
		}
		&__icon {
			flex-basis: 10px;
			fill: var(--black);
			margin-right: 5px;
			width: 13px;
		}
	}
	&__container {
		padding: 20px 30px;
		max-height: 60vh;
		overflow-y: auto;
	}
	&__group {
		&__title {
			margin: 0;
			margin-bottom: 5px;
			color: var(--black);
			font-size: var(--font-large);
			text-align: center;
		}
		&__desc {
			margin: 0;
			margin-top: 10px;
			padding-bottom: 15px;
			font-size: var(--font-smallest);
			color: var(--light-black);
			text-align: center;
			font-weight: var(--font-weight-lighter);
		}
		&__actions {
			display: flex;
			flex-direction: column;
		}
		&__action {
			background: none;
			text-align: left;
			border: none;
			padding: 10px;
			color: var(--dark-blue);
			font-size: var(--font-small);
			position: relative;
			padding-right: 5px;
			display: flex;
			flex-direction: row;
			border: 1px solid var(--main-bg-color);
			border-radius: 8px;
			margin-bottom: 5px;
			&.active {
				background-repeat: no-repeat;
				background-position: 97% center;
				background-image: url("data:image/svg+xml,%0A%3Csvg width='14' height='11' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.75781 10.7539C4.86719 10.918 5.03125 10.9727 5.25 10.9727C5.44141 10.9727 5.60547 10.918 5.74219 10.7539L13.8086 2.71484C13.918 2.60547 14 2.44141 14 2.22266C14 2.03125 13.918 1.86719 13.8086 1.73047L12.7969 0.746094C12.6602 0.609375 12.4961 0.527344 12.3047 0.527344C12.1133 0.527344 11.9492 0.609375 11.8125 0.746094L5.25 7.30859L2.1875 4.24609C2.02344 4.10938 1.85938 4.02734 1.66797 4.02734C1.47656 4.02734 1.3125 4.10938 1.20312 4.24609L0.191406 5.23047C0.0546875 5.36719 0 5.53125 0 5.72266C0 5.94141 0.0546875 6.10547 0.191406 6.21484L4.75781 10.7539Z' fill='%2360981A'/%3E%3C/svg%3E%0A");
			}

			&__remove {
				background: none;
				outline: none;
				border: none;
			}
			&__apply {
				background: none;
				outline: none;
				border: none;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				text-align: left;
				max-width: 90%;
			}
			&__name {
				font-size: var(--font-small);
				margin-bottom: 5px;
			}
			&__desc {
				font-size: var(--font-smallest);
				color: var(--light-black);
				margin-bottom: 5px;
			}
		}
	}
	&__apply {
		background: var(--green);
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		line-height: 20px;
		border: none;
		padding: 8px 0;
		text-align: center;
		color: var(--always-white);
		display: block;
		width: 100%;
		margin-bottom: 10px;
	}
	&__reset {
		background: none;
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		line-height: 20px;
		border: none;
		padding: 0 0 10px 0;
		text-align: center;
		color: var(--black);
		display: block;
		width: 100%;
	}
}
</style>
